import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { useAuthStore } from "../../../console/store/useAuthStore";
import { enum_api_uri } from "../utils/enum";

interface Category {
    event_category_idx: number;
    event_name: string;
}

export interface WordsData {
    word_idx: number;
    wreath_word: string;
    search_word: string;
    category: Category;
}

interface GetWordsResponse {
    data: WordsData[];
}

export const useGetCommonWords = (searchtxt?: string, event_category_idx?: number): UseQueryResult<GetWordsResponse, Error> => {
    const accessToken = useAuthStore(state => state.accessToken);

    let url = enum_api_uri.common_get_word;

    const params = []; // 쿼리 매개변수를 저장할 배열

    if (event_category_idx) {
        params.push(`event_category_idx=${event_category_idx}`);
    }
    if (searchtxt) {
        params.push(`search=search_word&searchtxt=${encodeURIComponent(searchtxt)}`);
    }

    // 쿼리 매개변수가 있는 경우 URL에 추가
    if (params.length > 0) {
        url += `?${params.join("&")}`;
    }

    return useQuery<GetWordsResponse, Error>({
        queryKey: ["getCommonWords", searchtxt, event_category_idx],
        queryFn: async () => {
            const response = await axios.get(url, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                // params: {
                //     search: "search_word",
                //     searchtxt,
                // },
                // params: {
                //     search: ["search_word", ""],
                //     searchtxt,
                // },
            });
            return response.data;
        },
    });
};
